/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tall_Fair_Swan_CallInputs */

const en_tall_fair_swan_call = /** @type {(inputs: Tall_Fair_Swan_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset filters`)
};

const de_tall_fair_swan_call = /** @type {(inputs: Tall_Fair_Swan_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter zurücksetzen`)
};

/**
* | output |
* | --- |
* | "Reset filters" |
*
* @param {Tall_Fair_Swan_CallInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tall_fair_swan_call = /** @type {((inputs?: Tall_Fair_Swan_CallInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tall_Fair_Swan_CallInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tall_fair_swan_call(inputs)
	return de_tall_fair_swan_call(inputs)
});